"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Context = require("./Context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PricewatchSubscribeFormDescription = function PricewatchSubscribeFormDescription() {
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
    isMobile = _useContext.isMobile,
    state = _useContext.state,
    STATE = _useContext.STATE,
    isNotConfirmedUser = _useContext.isNotConfirmedUser;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  if (state === STATE.ERROR || isNotConfirmedUser) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    isMobile: isMobile,
    isEdit: state === STATE.EDIT,
    isDone: state === STATE.DONE
  }, t('subscribe.description'));
};
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "PricewatchSubscribeFormDescription__StyledDescription",
  componentId: "sc-12f3tlt-0"
})(["white-space:break-spaces;display:flex;color:var(--grey1);font-size:12px;font-style:normal;font-weight:400;line-height:14px;", ";", ";"], function (_ref) {
  var isDone = _ref.isDone;
  return isDone && (0, _styledComponents.css)(["justify-content:center;"]);
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0, _styledComponents.css)(["align-items:center;font-size:16px;line-height:20px;"]);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeFormDescription);